export default __webpack_public_path__ + "69502d3e89a3174c41e7b26ae21c3fa0.svg";